import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { alpha } from "@material-ui/core/styles";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import * as Var from "../../styles/variables";
import FilterDrawer from "../../components/Filter/FilterDrawer";
import FilterDrawerNtt from "../../components/Filter/FilterDrawerNtt";
import FilterDrawerNttFt from "../../components/Filter/FilterDrawerNttFt";
import FilterDrawerHokuden from "../../components/Filter/FilterDrawerHokuden";
import {
  setCurrentPageNumber,
  setFilterDrawerState,
  setFilterType,
  setDateRange,
  setMinMaxDateRange,
  getSavedSelectedTagDataByEmail,
  getHomeImageData,
  getReportData,
  getHomeImageDataNtt,
  getReportDataNtt,
  getHomeImageDataHokuden,
  getReportDataHokuden,
} from "../../actions";
import moment from "moment";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: alpha("#fafafa", 1),
      marginTop: theme.spacing(-2),
      zIndex: 1000,
      paddingTop: 0,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      width: 300,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    calendarSection: {
      marginTop: "10px",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
      color: Var.btnLabelColor,
    },
    sectionCalendar: {
      display: "flex",
    },
    filterBtn: {
      marginTop: theme.spacing(1.2),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
    },
  })
);

const Calendar = ({
  companyName,
  currentPage,
  setDateRange,
  dateRange,
  minMaxDateRange,
  setCurrentPageNumber,
  getSavedSelectedTagDataByEmail,
  getHomeImageData,
  setFilterDrawerState,
  periodType,
  seasonData,
  missionData,
  selectedSeason,
  setMinMaxDateRange,
  selectedMission,
  filterStore,
  filterType,
  setFilterType,
  getReportData,
  getHomeImageDataNtt,
  getReportDataNtt,
  getHomeImageDataHokuden,
  getReportDataHokuden,
}) => {
  const anchor = "right";
  const classes = useStyles();
  const [error, setError] = useState([null, null]);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [isFutureOnly, setIsFutureOnly] = useState(false);
  const isNtt = companyName === "ntt";
  const isHokuden = companyName === "hokuden";

  useEffect(() => {
    if (currentPage.includes("home")) {
      setFilterType("photo");
    } else {
      setFilterType("report");
    }
  }, [currentPage]);

  useEffect(() => {
    const nowJstString = moment().tz("Asia/Tokyo").format("YYYY-MM-DDTHH:mm:ss");
    const nowJst = moment.utc(nowJstString); // JST を UTC 扱いでパース
    let maxDays = isNtt ? 3 : isHokuden ? 2 : 3;
    if (companyName === "ntt-ft") {
      maxDays = 8; // NTT FT Poc の場合は最大7日間
    }

    if (periodType === "season") {
      const selectedSeasonData = seasonData.find(
        (season) => season.seasonId === selectedSeason
      );
      if (selectedSeasonData) {
        const seasonStart = moment(selectedSeasonData.seasonStart);
        const seasonEnd = moment(selectedSeasonData.seasonEnd);

        // 将来シーズン開始のときは開始日＝終了日＝seasonStartに固定
        if (seasonStart.isAfter(nowJst)) {
          setDateRange([seasonStart.toDate(), seasonStart.toDate()]);
          setMinMaxDateRange([seasonStart.toDate(), seasonStart.toDate()]);
          setIsFutureOnly(true);
          return;
        }

        const endDate = moment.min(seasonEnd, nowJst);
        const startCandidate = endDate.clone().subtract(maxDays - 1, "days");
        const startDate = moment.max(seasonStart, startCandidate);

        setDateRange([startDate.toDate(), endDate.toDate()]);
        setMinMaxDateRange([seasonStart.toDate(), endDate.toDate()]);

        const todayJst = moment().tz("Asia/Tokyo").startOf("day");
        const isStartFuture = seasonStart.isAfter(todayJst);
        const isEndFuture = seasonEnd.isAfter(todayJst);

        setIsFutureOnly(isStartFuture && isEndFuture);
      }
    } else {
      // Mission
      const selectedMissionData = missionData.find(
        (mission) => mission.missionId === selectedMission
      );
      if (selectedMissionData) {
        const missionStart = moment(selectedMissionData.missionStart);
        const missionEnd = moment(selectedMissionData.missionEnd);

        const endDate = moment.min(missionEnd, nowJst);
        const startCandidate = endDate.clone().subtract(maxDays - 1, "days");
        const startDate = moment.max(missionStart, startCandidate);

        setDateRange([startDate.toDate(), endDate.toDate()]);
        setMinMaxDateRange([missionStart.toDate(), endDate.toDate()]);
      }
    }
  }, [selectedSeason, selectedMission]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
    setFilterDrawerState(open);
  };

  const fetchData = () => {
    setCurrentPageNumber(1);
    if (filterStore.tag.length > 0) {
      getSavedSelectedTagDataByEmail();
    } else {
      if (currentPage.includes("report")) {
        if (companyName === "ntt" || companyName === "ntt-ft") {
          getReportDataNtt({
            pageNumber: 1,
          });
        } else if (companyName === "hokuden") {
          getReportDataHokuden({
            pageNumber: 1,
          });
        } else if (companyName === "tepco") {
          getReportData({
            pageNumber: 1,
          });
        }
      } else {
        if (companyName === "ntt" || companyName === "ntt-ft") {
          getHomeImageDataNtt({
            pageNumber: 1,
          });
        } else if (companyName === "hokuden") {
          getHomeImageDataHokuden({
            pageNumber: 1,
          });
        } else if (companyName === "tepco") {
          getHomeImageData({
            pageNumber: 1,
          });
        }
      }
    }
  };

  const renderContent = () => {
    if (companyName === "tepco") return (
      <FilterDrawer
        toggleDrawer={toggleDrawer}
        anchor={anchor}
        filterType={filterType}
      />
    );
    if (companyName === "ntt") return (
      <FilterDrawerNtt
        toggleDrawer={toggleDrawer}
        anchor={anchor}
        filterType={filterType}
      />
    );
    if (companyName === "ntt-ft") return (
      <FilterDrawerNttFt
        toggleDrawer={toggleDrawer}
        anchor={anchor}
        filterType={filterType}
      />
    );
    if (companyName === "hokuden") return (
      <FilterDrawerHokuden
        toggleDrawer={toggleDrawer}
        anchor={anchor}
        filterType={filterType}
      />
    );
    return null;
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3} direction="row">
        <Grid item>
          <DateRangePicker
            startText="開始"
            endText="終了"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minMaxDateRange[0] !== null ? minMaxDateRange[0] : null}
            maxDate={minMaxDateRange[1] !== null ? minMaxDateRange[1] : null}
            value={dateRange}
            onChange={(newValue) => {
              setDateRange(newValue);
            }}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  helperText=""
                />
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  helperText=""
                />
              </div>
            )}
          />
        </Grid>
        <Grid item>
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
            //disabled={isFutureOnly}
          >
            表示
          </Button>
        </Grid>
        <Grid item>
          <Button
            className={classes.filterBtn}
            variant="contained"
            color="default"
            onClick={toggleDrawer(anchor, true)}
          >
            絞り込み
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {renderContent()}
          </Drawer>
        </Grid>
      </Grid>
    </div>
  );
};

Calendar.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  currentPage: state.app.currentPage,
  dateRange: state.app.dateRange,
  minMaxDateRange: state.app.minMaxDateRange,
  filterDrawerState: state.app.filterDrawerState,
  periodType: state.app.periodType,
  seasonData: state.app.seasonData,
  missionData: state.app.missionData,
  selectedSeason: state.app.selectedSeason,
  selectedMission: state.app.selectedMission,
  filterStore: state.home.filter,
  filterType: state.app.filterType,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  setDateRange: (param) => dispatch(setDateRange(param)),
  setMinMaxDateRange: (param) => dispatch(setMinMaxDateRange(param)),
  setFilterDrawerState: (param) => dispatch(setFilterDrawerState(param)),
  setFilterType: (param) => dispatch(setFilterType(param)),
  getSavedSelectedTagDataByEmail: () => dispatch(getSavedSelectedTagDataByEmail()),
  getHomeImageData: (param) => dispatch(getHomeImageData(param)),
  getReportData: (param) => dispatch(getReportData(param)),
  getHomeImageDataNtt: (param) => dispatch(getHomeImageDataNtt(param)),
  getReportDataNtt: (param) => dispatch(getReportDataNtt(param)),
  getHomeImageDataHokuden: (param) => dispatch(getHomeImageDataHokuden(param)),
  getReportDataHokuden: (param) => dispatch(getReportDataHokuden(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(Calendar));
